<template>
  <div>
    <v-dialog v-if="$vuetify.breakpoint.mdAndUp" v-model="modal" width="660">
      <v-card style="padding: 18px 0px">
        <v-card-text>
          <div class="d-flex justify-space-between headerModal">
            <div class="titleCard">
              تعیین وضعیت بسته
            </div>
            <!--            <div>-->
            <!--              <img src="../../assets/image/user-journey/icon-x.png" alt="">-->
            <!--            </div>-->
          </div>
          <div class="cartContent">
            <div class="descCard">
              یک بسته ی رزرو شده، به شرح زیر برای شما در سیستم وجود دارد. لطفا نسبت به پرداخت یا حذف آن اقدام نمایید.
            </div>
            <div class="detailBox">
              <div class="titleDetailBox">
                جزئیات بسته
              </div>
              <div>
                <div class="contentBox">
                  <div class="detailContent">
                    <div class="detailTitle">نوع بسته</div>
                    <div class="detailValue">{{ request.cart.cart_packages[0].package.title }}</div>
                  </div>
                  <div class="detailContent">
                    <div class="detailTitle">مبلغ قابل پرداخت</div>
                    <div class="detailValue" style="font-family: Roboto !important;">
                      {{ request.cart.final_amount }} $
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="doctorArea">
              <div class="doctorBox" st>
                <div class="doctorBoxHeader d-flex">
                  <div>
                    <img :src="request.doctor.user.avatar" width="84px" alt="">
                  </div>
                  <div class="d-flex flex-column justify-center mr-3">
                    <div class="therapistName">
                      دکتر
                      {{ request.doctor.user.full_name }}
                    </div>
                    <div class="therapistSubtitle mt-3">
                      {{ request.doctor.subtitle }}
                    </div>
                  </div>
                </div>
                <div class="detailDoctor">
                  <v-row class="">
                    <v-col cols="12" lg="4">
                      <div class="d-flex ">
                        <div class="iconDetail d-flex  flex-column justify-center">
                          <img src="../../assets/image/user-journey/Time_Zone.svg" alt="">
                        </div>
                        <div class="nameDetail  d-flex flex-column justify-center">
                          محدوده زمانی:
                        </div>
                      </div>
                      <div class="valueDetail">
                        {{ profile.tz }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="detailItem flex-column">
                        <div class="d-flex">
                          <div class="iconDetail d-flex flex-column justify-center">
                            <img src="../../assets/image/user-journey/calendar.svg" alt="">
                          </div>
                          <div class="nameDetail mx-1 d-flex flex-column justify-center">
                            تاریخ جلسه:
                          </div>
                        </div>
                        <div class="valueDetail">
                          {{ request.date_time.from_time | jalaliDateTimePartOne }}
                        </div>

                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="detailItem flex-column">
                        <div class="d-flex">
                          <div class="iconDetail d-flex flex-column justify-center">
                            <img src="../../assets/image/user-journey/clock.svg" alt="">
                          </div>
                          <div class="nameDetail mx-1 d-flex flex-column justify-center">
                            ساعت جلسه:
                          </div>
                        </div>
                        <div class="valueDetail">
                          {{ request.date_time.from_time | jalaliDateTimeWithoutLabel }}
                          {{ request.date_time | getDayPeriodsLabel }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

            </div>
            <v-row class="mt-5 px-2">
              <v-col cols="6" class="pa-0 ma-0 px-1">
                <v-btn color="#39C990" elevation="0" @click="payFactor" style="color: white !important;"
                       class="confirmBtn white--text"
                       block>
                  ادامه فرایند خرید
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 px-1">
                <v-btn color="#39C990" @click="canceledFlow" outlined elevation="0" class=" confirmBtnOutline"
                       block>
                  حذف بسته و شروع مجدد
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet style="border-radius: 16px 16px 0px 0px " v-model="modal" v-else app height="80%"
                    scrollable>
      <v-card style="padding: 0px 0px 18px 0px ;border-radius: 16px 16px 0px 0px ">
        <v-card-title class="d-flex justify-space-between headerModal">
          <div class="titleCard">
            تعیین وضعیت بسته
          </div>
          <!--            <div>-->
          <!--              <img src="../../assets/image/user-journey/icon-x.png" alt="">-->
          <!--            </div>-->
        </v-card-title>
        <v-card-text>

          <div class="cartContent">
            <div class="descCard">
              یک بسته ی رزرو شده، به شرح زیر برای شما در سیستم وجود دارد. لطفا نسبت به پرداخت یا حذف آن اقدام نمایید.
            </div>
            <div class="detailBox">
              <div class="titleDetailBox">
                جزئیات بسته
              </div>
              <div>
                <div class="contentBox">
                  <div class="detailContent">
                    <div class="detailTitle">نوع بسته</div>
                    <div class="detailValue">{{ request.cart.cart_packages[0].package.title }}</div>
                  </div>
                  <div class="detailContent">
                    <div class="detailTitle">مبلغ قابل پرداخت</div>
                    <div class="detailValue" style="font-family: Roboto !important;">
                      {{ request.cart.final_amount }} $
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="doctorArea">
              <div class="doctorBox" st>
                <div class="doctorBoxHeader d-flex">
                  <div>
                    <img :src="request.doctor.user.avatar" width="84px" alt="">
                  </div>
                  <div class="d-flex flex-column justify-center mr-3">
                    <div class="therapistName">
                      دکتر
                      {{ request.doctor.user.full_name }}
                    </div>
                    <div class="therapistSubtitle mt-3">
                      {{ request.doctor.subtitle }}
                    </div>
                  </div>
                </div>
                <div class="detailDoctor">
                  <v-row class="">
                    <v-col cols="12" lg="4">
                      <div class="d-flex ">
                        <div class="iconDetail d-flex  flex-column justify-center">
                          <img src="../../assets/image/user-journey/Time_Zone.svg" alt="">
                        </div>
                        <div class="nameDetail  d-flex flex-column justify-center">
                          محدوده زمانی:
                        </div>
                      </div>
                      <div class="valueDetail">
                        {{ profile.tz }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="detailItem flex-column">
                        <div class="d-flex">
                          <div class="iconDetail d-flex flex-column justify-center">
                            <img src="../../assets/image/user-journey/calendar.svg" alt="">
                          </div>
                          <div class="nameDetail mx-1 d-flex flex-column justify-center">
                            تاریخ جلسه:
                          </div>
                        </div>
                        <div class="valueDetail">
                          {{ request.date_time.from_time | jalaliDateTimePartOne }}
                        </div>

                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="detailItem flex-column">
                        <div class="d-flex">
                          <div class="iconDetail d-flex flex-column justify-center">
                            <img src="../../assets/image/user-journey/clock.svg" alt="">
                          </div>
                          <div class="nameDetail mx-1 d-flex flex-column justify-center">
                            ساعت جلسه:
                          </div>
                        </div>
                        <div class="valueDetail">
                          {{ request.date_time.from_time | jalaliDateTimeWithoutLabel }}
                          {{ request.date_time | getDayPeriodsLabel }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-row class="mt-5 px-2">
            <v-col cols="6" class="pa-0 ma-0 px-1">
              <v-btn color="#39C990" elevation="0" @click="payFactor" style="color: white !important;"
                     class="confirmBtn white--text"
                     block>
                ادامه فرایند خرید
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 ma-0 px-1">
              <v-btn color="#39C990" @click="canceledFlow" outlined elevation="0" class=" confirmBtnOutline"
                     block>
                حذف بسته و شروع مجدد
              </v-btn>
            </v-col>
          </v-row>

        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import momentJalali from "moment-jalaali";
import {clearJourneyStorage} from "@/utils/journeyToken";

export default {
  data() {
    return {
      modal: false,
      request: null,
    }
  },
  methods: {
    canceledFlow() {
      this.$emitEvent('setLoading', true)
      this.requesting('setSession', 'canceledFlow', {}, {
        "flow_id": this.request.id
      }).then(() => {
        this.restartTest()
      }).finally(() => {
        // this.$emitEvent('setLoading', false)
      })
    },
    restartTest() {
      clearJourneyStorage()
      setTimeout(() => {
        location.reload();
      }, 500)
    },
    payFactor() {
      this.$emitEvent('setLoading', true)
      this.requesting('setSession', 'selectPackage', {}, {
        token: this.request.token,
        package_id: this.request.cart.cart_packages[0].package_id,
        cart_id: this.request.cart_id
      }).then((resp) => {
        window.location = resp.data.payment.url
      }).finally(() => {
        // this.$emitEvent('setLoading', false)
      })
    },
    getRequest() {
      if(this.isLoggedIn){
        this.requesting('setSession', 'getCartSubmitted').then((resp) => {
          this.request = resp.data.journey
          if (this.request) {
            this.modal = true
          }
        })
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      'isLoggedIn': 'getIsLoggedIn'
    })
  },
  mounted() {
    this.getRequest()
  },
  filters: {

    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      console.log(hour, '1212')
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return 'شب'
        }
      }
    },
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD - [ساعت] hh:mm');
    },
    jalaliDateTimePartOne(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD ');
    },
    jalaliDateTimePartTwo(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format(' [ساعت] hh:mm');
    },
    jalaliDateTimeWithoutLabel(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format('  hh:mm');
    },

  },
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 800px) {
  .descCard {
    font-size: 18px !important;
  }

  .detailValue {
    font-size: 15px !important;
    text-align: left !important;
  }
}

.confirmBtnOutline{
  //font-size: ;
  font-weight: 500;
  font-size: 16px;
}

.doctorArea {
}

.contentBox {
  padding: 0px 16px 16px 16px;
}

.detailContent {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;

}

.detailTitle {
  color: #212121;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.detailValue {
  color: #212121;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: "YekanBakh", "Roboto" !important;
}


.detailBox {
  border: 1px solid #DBE4ED;
  margin-top: 16px;
  border-radius: 8px;
}

.descCard {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 16px;
}

.titleDetailBox {
  padding: 8px 16px;
  border-bottom: 1px solid #DBE4ED;
  color: #212121;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.headerModal {
  border-bottom: 1px solid #DBE4ED;
  padding-bottom: 5px;
}

.titleCard {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>